import { withType } from "../../../utils/actionOperations";
import { RENDER_PDF_INIT } from "../../constants";

export const initReportData = (editable, reportType) => {
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_INIT, { editable: !!editable, reportType }));
  };
};
